class TH_Initer {
    constructor() {
        this.registers = {};
    }

    /** Unregister a registered initializiation function
     * 
     * @param string regIdentifier (the identifier to unregister)
     * 
     */
    unregister(regIdentifier) {
        delete this.registers[regIdentifier];

        return this;
    }

    /** Register an initialization function
     * 
     * @param string    name             (the name of the register)
     * @param function  registerFunc     (the function to run when this register is run)
     * @param array     additionalParams (additional params to send to the function)
     * @param bool      runOnce          (optional, defaults to false, specifies if this should be run only once, when the first Init.all() is called, then destreyod)
     * 
     */
    addRegister(name, registerFunc, registerThis, additionalParams, runOnce) {
        if (typeof registerThis == 'undefined') registerThis = this;
        if (typeof runOnce == 'undefined') runOnce = false;
        if (typeof additionalParams == 'undefined') additionalParams = [];

        this.registers[name] = {
            function: registerFunc,
            registerThis: registerThis,
            runOnce: runOnce,
            additionalParams: additionalParams
        }
    }

    all() {
        console.log("Performing all initialization", this.registers);
        for (let regFuncIdentifier in this.registers) {
            console.log(regFuncIdentifier);
            this.registers[regFuncIdentifier].function.apply(this.registers[regFuncIdentifier].registerThis, this.registers[regFuncIdentifier].additionalParams.concat([regFuncIdentifier]));
            if (this.registers[regFuncIdentifier].runOnce === true) delete this.registers[regFuncIdentifier];
        }
    }
}

export default TH_Initer;
